import type { CartDiscountDto, CartTaxDto } from '@bondsports/types';
import { formatPercentage, formatPrice } from '@utils';
import { defaultLabels } from '../labels/labels';

export const getDiscountLabel = (discount: CartDiscountDto, currency: string, locale?: string) => {
	let amount;
	if (discount.percentage) {
		amount = formatPercentage(discount.percentage, { locale, negative: true });
	} else {
		amount = formatPrice(discount.discountAmount, {
			locale,
			currency,
		});
	}
	return `${discount.reason?.reason ?? ''} (${amount})`;
};

export const getTaxLabel = (tax: CartTaxDto, locale?: string) => {
	return `${tax.name} (${formatPercentage(tax.rate, { locale })}${tax.isInclusive ? ` ${defaultLabels.taxInclusive}` : defaultLabels.taxExclusive})`;
};
